import React, { FC, useRef, useState, useEffect } from "react";
import styles from "./signUp-slider.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Navigate, useNavigate } from "react-router-dom";

const CustomSlider: FC = () => {
  const sliderRef = useRef<Slider>(null);
  const navigate = useNavigate()

  const next = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const previous = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "green" }}
        onClick={onClick}
      />
    );
  }
  const [containerClass, setContainerClass] = useState('container');
  const [number, setNumber] = useState(3);

  const handleResize = () => {

    if (window.innerWidth < 577) {
      setNumber(1);
    } else if (window.innerWidth < 769) {
      setNumber(2);
    } else {
      setNumber(3);
    }

    if (window.innerWidth < 992) {
      setContainerClass('container-fluid');
    } else {
      setContainerClass('container');
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const goToBuyer = () => {
    navigate('/buyer')
  }
  const goToSeller = () => {
    navigate('/seller')
  }

  const goToTrading = () => {
    navigate('/trading')
  }

  const navigatingBtn = (destination: string) => {
    if (destination === "buyer") {
      navigate('/buyer')
    } else if (destination === "know-how") {
      navigate('/know-how')
    } else if (destination === "seller") {
      navigate('/seller')
    } else if (destination === "trading") {
      navigate('/trading')
    }
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: number,
    slidesToScroll: number,
    autoplay: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className={styles["slider_container"]}>
      <div className={`slider_box ${containerClass} `}>
        <Slider ref={sliderRef} {...settings} >
          <div className="card_box d-flex flex-column justify-content-center align-items-center">
            <div className="title d-flex justify-content-center">我想買電</div>
            <div className="img_container">
              <div className="img_content d-flex justify-content-center align-items-center">
                <img
                  className="transactions_img"
                  src="/assets/images/home/transactions/user.svg"
                  alt=""
                />
                <span className="transactions_subTitle">個人用戶</span>
              </div>
              <div className="img_content d-flex justify-content-center align-items-center">
                <img
                  className="transactions_img"
                  src="/assets/images/home/transactions/company.svg"
                  alt=""
                />
                <span className="transactions_subTitle">企業用電</span>
              </div>
            </div>
            <div className="transactions_desc d-flex flex-column justify-content-center align-items-center">
              <span className="desc_content">價格公開、多元選擇</span>
              <span className="desc_content">讓用戶有更多方式達成目標</span>
              <span className="desc_content">個體用戶對綠電也不再有距離</span>
            </div>
            <div className="transactions_btn_box">
              <button onClick={() => navigatingBtn('buyer')} className="transactions_btn">註冊買家</button>
              <button onClick={() => navigatingBtn('know-how')} className="transactions_btn">如何購電</button>
            </div>
          </div>

          <div className="card_box card_dark d-flex flex-column justify-content-center align-items-center">
            <div className="title yellow_border_bottom d-flex justify-content-center color_fff">
              我想賣電
            </div>
            <div className="img_container d-flex justify-content-center align-items-center">
              <img
                className="transactions_img img_bigger"
                src="/assets/images/home/transactions/service.svg"
                alt=""
              />
              <span className="transactions_subTitle text_bigger color_fff">
                我有電廠
              </span>
            </div>
            <div className="transactions_desc  d-flex flex-column justify-content-center align-items-center">
              <span className="desc_content color_fff">
                自行選擇想合作的夥伴
              </span>
              <span className="desc_content color_fff">
                明朗的預購價格，多元合作模式
              </span>
              <span className="desc_content color_fff">
                讓我們替您將效益最大化
              </span>
            </div>
            <div className="transactions_btn_box">
              <button onClick={() => navigatingBtn('seller')} className="transactions_btn btn_yellow">
                註冊成為賣家
              </button>
            </div>
          </div>

          <div className="card_box d-flex flex-column justify-content-center align-items-center">
            <div className="title d-flex justify-content-center">交易模式</div>
            <div className="img_container d-flex justify-content-center align-items-center">
              <img
                className="transactions_img img_bigger"
                src="/assets/images/home/transactions/money.svg"
                alt=""
              />
              <span className="transactions_subTitle text_bigger">
                多元化交易
              </span>
            </div>
            <div className="transactions_desc d-flex flex-column justify-content-center align-items-center">
              <span className="desc_content">多元化的量能、自由的選擇</span>
              <span className="desc_content">客製化滿足需求、目標達成等等</span>
              <span className="desc_content">
                都能在這裡實現 Reach the Goal
              </span>
            </div>
            <div className="transactions_btn_box">
              <button onClick={() => navigatingBtn('trading')} className="transactions_btn">點我了解更多</button>
            </div>
          </div>
        </Slider>
      </div>

      <div className="slider_btn_box">
        <button className="preBtn" onClick={previous}>
          <img src="/assets/images/slider/arrow_L.png" alt="" />
        </button>
        <button className="nextBtn" onClick={next}>
          <img src="/assets/images/slider/arrow_R.png" alt="" />
        </button>
      </div>

    </div>
  );
};

export default CustomSlider;
